import { type Html, html, View } from 'rune-ts';
import { makeUtilScreenNavigate } from '../../../../../../shared/app/navigate';
import klass from './ProductStoreName.module.scss';
import { dataStr } from '../../../../../../shared/util/dataStr';
import { CreatorNameView } from '@services/MarppleShop/renderApp/components/cells/CreatorName/CreatorNameView.ts';

type ProductStoreNameData = {
  store_name: string;
  domain_name: string;
  profile_image_url?: string | null;
  is_partner: boolean;
};

export class ProductStoreName extends View<ProductStoreNameData> {
  post_message = this.makePostMessage();

  constructor(
    data: ProductStoreNameData,
    private option: { klass?: string; suffix?: Html },
  ) {
    if (!option.klass) {
      option.klass = '';
    }
    super(data, option);
  }

  protected override template() {
    return html`
      <a
        href="${this.makeLink()}"
        data-post-message="${dataStr(this.post_message)}"
        class="${this.option.klass} ${klass.name}"
      >
        ${new CreatorNameView({
          name: html`${html.preventEscape(this.data.store_name)}${this.option.suffix || ''}`,
          size: 'small',
          is_partner: this.data.is_partner,
        })}
      </a>
    `;
  }

  private makeLink() {
    return `/${T.lang}/${this.data.domain_name}`;
  }

  private makePostMessage() {
    return makeUtilScreenNavigate(this.makeLink());
  }
}
